








import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  setup ({ count }) {
    const doubleCount = computed(() => count * 2)

    return { doubleCount }
  }
})
